import type { Language } from '../types'
import type { PlaceProvider, PlaceSearchResponse } from './PlaceProvider'

export class FallbackPlaceProvider implements PlaceProvider {
  readonly name = 'FallbackPlaceProvider'

  constructor(
    private readonly primary: PlaceProvider,
    private readonly fallback: PlaceProvider,
  ) {}

  async search(query: string, language: Language): Promise<PlaceSearchResponse> {
    try {
      return await this.primary.search(query, language)
    } catch (error) {
      const fallbackResult = await this.fallback.search(query, language)
      const reason = error instanceof Error ? error.message : '장소 API를 사용할 수 없습니다.'
      return { ...fallbackResult, notice: `${reason} ${fallbackResult.notice ?? ''}`.trim() }
    }
  }
}
